module.exports = __webpack_public_path__ + "img/clear-filter.eaffbe5a.png";